module.exports = __webpack_public_path__ + "img/happy--pressed.9ddb7d67.svg";